import { TRACK_CREATE_STOCK_REQUEST } from '~gatsby-theme-autonomy/redux/actions/types'

export const trackCreateStockRequest = (email, sku) => {
  return {
    type: TRACK_CREATE_STOCK_REQUEST,
    email,
    sku,
  }
}
